import React from 'react';
import styled from 'styled-components';
import SignUpDepositLimits from './SignUpDepositLimits';
import ControlledPortalCheckBox from '../../../components/Input/ControlledPortalCheckBox';

const Agreements = ({ isSmallScreen }: AgreementsProps) => {
	return (
		<>
			<SignUpDepositLimits />
			<CheckBoxWrapper>
				<ControlledPortalCheckBox
					fieldName={'opted_in'}
					label={`Notify me about my offers via email, SMS and other direct means`}
				/>
			</CheckBoxWrapper>
		</>
	);
};

export default Agreements;

interface AgreementsProps {
	isSmallScreen: boolean;
}

const CheckBoxWrapper = styled.div({
	display: 'flex',
	alignItems: 'center',
	backgroundColor: '#F7F7F7',
	// justifyContent: 'center',
	padding: '7px',
	paddingBottom: '7px',
	marginTop: '20px',
	marginBottom: '20px',
	borderRadius: '4px',
});
